import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

// Item de detalle reutilizable: ícono + etiqueta + valor.
export default function DetailItem({ icon, label, value }) {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          flexShrink: 0,
          borderRadius: 2,
          bgcolor: "rgba(15, 76, 129, 0.08)",
          color: "primary.main",
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            fontWeight: 600,
            display: "block",
            lineHeight: 1.6,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, color: "text.primary", wordBreak: "break-word" }}
        >
          {value ?? "-"}
        </Typography>
      </Box>
    </Box>
  )
}
